// ------------------------------------
// Constants
// ------------------------------------
export const NETWORK_POLICIES_POST_REQUEST = "NETWORK_POLICIES_POST_REQUEST";
export const NETWORK_POLICIES_POST_REQUEST_SUCCESS =
  "NETWORK_POLICIES_POST_REQUEST_SUCCESS";
export const NETWORK_POLICIES_POST_REQUEST_FAILURE =
  "NETWORK_POLICIES_POST_REQUEST_FAILURE";
export const NETWORK_POLICIES_POST_RESET = "NETWORK_POLICIES_POST_RESET";

// ------------------------------------
// Actions
// ------------------------------------
export function request(data, resolve, reject) {
  return {
    type: NETWORK_POLICIES_POST_REQUEST,
    data,
    resolve,
    reject,
  };
}

export function requestSuccess(data) {
  return {
    type: NETWORK_POLICIES_POST_REQUEST_SUCCESS,
    data,
  };
}

export function requestFailure(error) {
  return {
    type: NETWORK_POLICIES_POST_REQUEST_FAILURE,
    error,
  };
}

export function reset() {
  return {
    type: NETWORK_POLICIES_POST_RESET,
  };
}
